import React, { useState } from 'react';

const FeatureCard = ({ title, subTitle, description, visual, badge, onClick, comingSoon }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      onClick={comingSoon ? undefined : onClick}
      onMouseEnter={() => !comingSoon && setIsHovered(true)}
      onMouseLeave={() => !comingSoon && setIsHovered(false)}
      style={{
        background: '#FFFFFF',
        borderRadius: '24px',
        padding: '24px',
        boxShadow: comingSoon ? 'none' : (isHovered ? '0 20px 40px rgba(0,0,0,0.1)' : '0 2px 8px rgba(0,0,0,0.04)'),
        border: `1px solid ${comingSoon ? '#E5E7EB' : (isHovered ? '#DBEAFE' : '#F3F4F6')}`,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        overflow: 'hidden',
        cursor: comingSoon ? 'not-allowed' : 'pointer',
        transition: 'all 0.3s ease',
        transform: (isHovered && !comingSoon) ? 'translateY(-4px)' : 'translateY(0)',
        filter: comingSoon ? 'blur(2px)' : 'none',
        pointerEvents: comingSoon ? 'none' : 'auto'
      }}
    >
      {/* Visual Area */}
      <div style={{
        background: 'linear-gradient(180deg, #F9FAFB 0%, #EFF6FF 100%)',
        borderRadius: '16px',
        height: '220px',
        width: '100%',
        marginBottom: '20px',
        position: 'relative',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '1px solid #F9FAFB'
      }}>
        {visual}
      </div>

      {/* Text Area */}
      <div style={{ marginTop: 'auto' }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          marginBottom: '8px'
        }}>
          <div>
            <span style={{
              color: '#3B82F6',
              fontSize: '12px',
              fontWeight: '700',
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
              marginBottom: '4px',
              display: 'block'
            }}>
              {subTitle}
            </span>
            <h3 style={{
              margin: 0,
              fontSize: '18px',
              fontWeight: '700',
              color: '#111827',
              lineHeight: '1.3'
            }}>
              {title}
            </h3>
          </div>
          {(badge || comingSoon) && (
            <span style={{
              background: comingSoon
                ? '#9CA3AF'
                : badge === 'HOT'
                  ? 'linear-gradient(135deg, #F97316 0%, #EF4444 100%)'
                  : badge === 'PRO'
                    ? '#000000'
                    : '#000000',
              color: '#FFFFFF',
              fontSize: '10px',
              fontWeight: '700',
              padding: '4px 8px',
              borderRadius: '9999px',
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
              marginLeft: '8px',
              flexShrink: 0
            }}>
              {comingSoon ? 'COMING SOON' : badge}
            </span>
          )}
        </div>
        <p style={{
          margin: 0,
          color: '#6B7280',
          fontSize: '14px',
          lineHeight: '1.6'
        }}>
          {description}
        </p>
      </div>
    </div>
  );
};

export default FeatureCard;
